import { EVisitorStatus } from 'modules/_common/consts/eVisitorStatus';
import { colors } from 'services/theme/constants';

type TeVisitorGuestStatus = {
  color: string;
  backgroundColor: string;
  borderColor: string;
  status: string;
};

export const eVisitorCheckGuestStatus = (status: string | null): TeVisitorGuestStatus => {
  switch (status) {
    case EVisitorStatus.PRIJAVLJEN:
      return {
        color: colors.green_90,
        backgroundColor: colors.green_10,
        borderColor: colors.green_90,
        status:
          String(EVisitorStatus.PRIJAVLJEN).toLowerCase().charAt(0).toUpperCase() +
          String(EVisitorStatus.PRIJAVLJEN).toLowerCase().slice(1),
      };
    case EVisitorStatus.ODJAVLJEN:
      return {
        color: colors.black_80,
        backgroundColor: colors.black_5,
        borderColor: colors.black_80,
        status:
          String(EVisitorStatus.ODJAVLJEN).toLowerCase().charAt(0).toUpperCase() +
          String(EVisitorStatus.ODJAVLJEN).toLowerCase().slice(1),
      };

    default:
      return {
        color: colors.black_80,
        backgroundColor: colors.negative_10,
        borderColor: colors.negative_dark,
        status:
          String(EVisitorStatus.NEPRIJAVLJEN).toLowerCase().charAt(0).toUpperCase() +
          String(EVisitorStatus.NEPRIJAVLJEN).toLowerCase().slice(1),
      };
  }
};
